import { render, staticRenderFns } from "./ActAsUserPicker.vue?vue&type=template&id=dfdc6c42&scoped=true&"
import script from "./ActAsUserPicker.vue?vue&type=script&lang=js&"
export * from "./ActAsUserPicker.vue?vue&type=script&lang=js&"
import style0 from "./ActAsUserPicker.vue?vue&type=style&index=0&id=dfdc6c42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdc6c42",
  null
  
)

export default component.exports